export default "__VITE_ASSET__Bb6vc2be__"